module.exports = __webpack_public_path__ + "img/w62.d9ee2a0a.svg";